import styled from 'styled-components';
import {ByocOnboardingContainer} from '../styles';

export const OrderSourceContainer = styled(ByocOnboardingContainer)`
  position: relative;
`;

export const OrderSourceField = styled.div`
  margin-top: 24px;
  width: 100%;

  &.mTop20 {
    margin-top: 20px;
  }

  &.mTop35 {
    margin-top: 35px;
  }

  &.positionRelative {
    position: relative;
  }
`;

export const ConnectButton = styled.div`
  margin-top: 16px;
  width: 100%;
  max-width: 200px;
`;

export const PlatformsSection = styled.div`
  position: relative;
  display: flex;
  gap: 20px;
  margin-top: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PlatformCard = styled.div`
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  padding: 24px;
  border: 2px solid ${(props) => (props.$isSelected ? '#ff2d38' : '#d5d8de')};
  border-radius: 10px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;

  &:hover {
    border-color: #ff2d38;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }

  &.commission {
    max-width: 150px;
    border: none;
    cursor: default;
    padding: 0;
    min-height: auto;
  }
`;

export const PlatformLogo = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #2f3d48;
  text-align: center;
  &.bSize {
    img {
      width: 110px;
    }
  }
`;

export const PlatformButton = styled.div`
  margin-top: 16px;
  width: 100%;
  &.flexCenter {
    display: flex;
    justify-content: center;
  }
`;

export const CommercialAgreementsSection = styled.div`
  margin-top: 35px;
  width: 100%;
`;

export const LabelWithInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  margin-bottom: 4px;
`;
